import { request } from '@/plugins/http';

/**
 * 储存信号配置列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDeployPage = params => request('/deploy/getDeployPage', params);

/**
 * 储存信号历史列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDeploy = params => request('/deploy/getDeploy', params);

/**
 * 储存信号历史列表
 * @param params
 * @returns {AxiosPromise}
 */
const addDeploy = params => request('/deploy/addDeploy', params);

/**
 * 删除
 * @param params
 * @returns {AxiosPromise}
 */
const deleteDeploy = params => request('/deploy/delDeploy', params);

export {
    getDeployPage,
    getDeploy,
    addDeploy,
    deleteDeploy
};
